import { Link } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { cn } from '#app/utils/misc.tsx'

export interface SimpleCtaProps {
	headline: string
	subheadline?: string
	buttonText: string
	buttonLink: string
	background?: 'default' | 'muted' | 'primary-light'
}

export function SimpleCta({
	headline,
	subheadline,
	buttonText,
	buttonLink,
	background = 'primary-light',
}: SimpleCtaProps) {
	const bgClasses = {
		default: 'bg-background',
		muted: 'bg-muted/30',
		'primary-light': 'bg-primary/5',
	}

	return (
		<section className={cn('py-16', bgClasses[background])}>
			<div className="container mx-auto flex max-w-4xl flex-col items-center gap-6 px-6 text-center">
				<span className="text-label text-primary">Da el siguiente paso</span>
				<h2 className="text-title-2 text-foreground">{headline}</h2>
				{subheadline && (
					<p className="text-muted-foreground max-w-2xl text-base md:text-lg">
						{subheadline}
					</p>
				)}
				<div className="flex flex-wrap justify-center gap-3">
					<Button asChild variant={'default'} className="h-11 px-8">
						<Link to={buttonLink}>{buttonText}</Link>
					</Button>
				</div>
			</div>
		</section>
	)
}
